import { render, staticRenderFns } from "./tricode_parent.vue?vue&type=template&id=37437890&scoped=true&"
import script from "./tricode_parent.vue?vue&type=script&lang=js&"
export * from "./tricode_parent.vue?vue&type=script&lang=js&"
import style0 from "./tricode_parent.vue?vue&type=style&index=0&id=37437890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37437890",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VIcon,VList,VMenu,VTreeview})
